@use '../../../../../../../../../styles/Constants.scss' as Constants;
@use '../../../../../../../../../styles/Colors.scss' as Colors;

$label-height: 16px;

.BillingTypeInfo {
	display: flex;
	flex-direction: column;
	flex: 1;

	.label {
		font-size: Constants.$val-fontSizeSmall;
		line-height: $label-height;
	}
}
